import to from 'await-to-js';
import OKA from '../';

export default {
    CancelAppointment: (id, token) => new Promise(async(resolve, reject) => {
        if (!OKA.http.appointment) reject(false);
        const [err, response] = await to(OKA.http.appointment.put(`/patientapp/appointments/${id}/cancel`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }));
        if (err) {
            reject(err)
        }

        resolve(response);            
    }),
    
    GetServices: (practitionerId) => new Promise(async(resolve, reject) => {
        if (!OKA.http.appointment) reject(false);
        if (practitionerId) {
            const [err, response] = await to(OKA.http.appointment.get(`/patientapp/doctors/${practitionerId}/services`));
            if (err) {
                reject(err)
            }

            resolve(response);
        }

        reject(new Error('practitionerId not found'))
    }),
    GetAvailability: (practitionerId, serviceId, month, facilityID) => new Promise(async(resolve, reject) => {
        if (!OKA.http.appointment) reject(false);
        if (practitionerId) {
            const params = {
                serviceTypeId: serviceId,
                month: month,
                facility_id: facilityID
            };
            const [err, response] = await to(OKA.http.appointment.get(`/patientapp/doctors/${practitionerId}/availability/dates`, {
                params
            }));
            if (err) {
                reject(err)
            }

            resolve(response);
        }

        reject(new Error('practitionerId not found'));
    }),
    GetAvailabilityByDate: (practitionerId, serviceId, date, facilityID) => new Promise(async(resolve, reject) => {
        if (!OKA.http.appointment) reject(false);
        if (practitionerId) {
            const params = {
                serviceTypeId: serviceId,
                date,
                facility_id: facilityID
            };
            const [err, response] = await to(OKA.http.appointment.get(`/patientapp/doctors/${practitionerId}/availability/times`, {
                params
            }));
            if (err) {
                reject(err)
            }

            resolve(response);
        }

        reject(new Error('practitionerId not found'));
    }),
    GetAppointment: (appointmentId, token) => new Promise(async(resolve, reject) => {
        if (!OKA.http.appointment) reject(false);
        if (appointmentId) {
            const [err, response] = await to(OKA.http.appointment.get(`/patientapp/appointments/${appointmentId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }));
            if (err) {
                reject(err)
            }

            resolve(response);
        }

        reject(new Error('appointmentId not found'));
    }),
};